import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import Collapsible from 'react-collapsible';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import _ from 'lodash';
import { appConfig } from './../../configureApp';
import AsyncButton from 'components/AsyncButton';
import LoginPage from 'containers/Login';

import messages from './messages';
import StepAppsureBankDetails from '../FastCover/Appsure.StepBankDetails';
// import Step4 from '../FastCover/Step4';
import StepWhatHappened from '../FastCover/StepWhatHappened';
import StepCancellationAdditional from '../FastCover/StepCancellationAdditional';
import StepPersonalItems from '../FastCover/StepPersonalItems';
import StepOverseasMedical from '../FastCover/StepOverseasMedical';
import StepRentalVehicle from '../FastCover/StepRentalVehicle';
import StepSnowSports from '../FastCover/StepSnowSports';
import StepOther from '../FastCover/StepOther';
import StepSupportingDocuments from '../FastCover/StepSupportingDocuments';
import StepClaimSummary from '../FastCover/StepClaimSummary';
import Step16 from '../FastCover/Step16';
import Step17 from '../FastCover/Step17';
import StepTripCancellationAndTripInterruption from '../FastCover/StepTripCancellationAndTripInterruption';
import StepBaggageAndPersonalItems from '../FastCover/StepBaggageAndPersonalItems';
import StepMedicalExpenses from '../FastCover/StepMedicalExpenses';
import StepPaymentDetails from '../FastCover/StepPaymentDetails';
import MedicalExpenseStep from '../FastCover/Trawick.NationWide.MedicalExpenseStep/';
import AccidentalDeathAndDismemberment from '../FastCover/Trawick.NationWide.AccidentalDeathAndDismembermentStep/';
import TripCancellationStep from '../FastCover/Trawick.NationWide.TripCancellationStep/';
import TripDelayStep from '../FastCover/Trawick.NationWide.TripDelayStep/';
import TripInterruptionStep from '../FastCover/Trawick.NationWide.TripInterruptionStep/';
import MissedConnectionStep from '../FastCover/Trawick.NationWide.MissedConnectionStep/';
import PetMedicalStep from '../FastCover/Trawick.NationWide.PetMedicalStep/';
import CollisionDamageStep from '../FastCover/Trawick.NationWide.CollisionDamageStep/';
import PropertyDamageStep from '../FastCover/Trawick.NationWide.PropertyDamageStep/';
import BaggageAndPersonalStep from '../FastCover/Trawick.NationWide.PersonalItemStep/';
import SportsEquipmentStep from '../FastCover/Trawick.NationWide.SportsEquipmentStep/';
import MedicalHardshipStep from '../FastCover/Trawick.DuesProtect.MedicalHardshipStep/';
import JobLossHardshipStep from '../FastCover/Trawick.DuesProtect.JobLossHardshipStep/';
import MedicalExpenseCFStep from '../FastCover/Trawick.CFTripCan.MedicalExpense/';
import MedicalExpenseZurichStep from '../FastCover/Trawick.Zurich.MedicalExpense/';
import TripCancellationCFStep from '../FastCover/Trawick.CFTripCan.TripCancellationStep/';
import BaggagePersonalEffects from '../FastCover/Trawick.CFTripCan.BaggagePersonalEffects/';
import ItineraryChange from '../FastCover/Trawick.CFTripCan.ItineraryChange/';
import StepTravelDelay from '../FastCover/StepTravelDelay/';
import MedicalAndEvacuationSCTIStep from '../FastCover/Trawick.SCTI.MedicalAndEvacuation/';
import ChangesToYourJourneySCTIStep from '../FastCover/Trawick.SCTI.ChangesToYourJourney/';
import BaggageAndPersonalItemsSCTIStep from '../FastCover/Trawick.SCTI.BaggageAndPersonalItems/';
import CashBankCardsTravelDocumentsAndPassportsStep from '../FastCover/Trawick.SCTI.CashBankCardsTravelDocumentsAndPassports/';
import PersonalAccidentSCTIStep from '../FastCover/Trawick.SCTI.PersonalAccident/';
import RentalVehicleExcessSCTIStep from '../FastCover/Trawick.SCTI.RentalVehicleExcess/';
import ChangesToYourJourneyStep from '../FastCover/Trawick.ChangesToYourJourney/';
import BaggageAndPersonalItemsStarrStep from '../FastCover/Trawick.Starr.StepBaggageAndPersonalItems/';
import StepOtherStarr from '../FastCover/Trawick.Starr.StepOther/';
import CollisionDamageStarrStep from '../FastCover/Trawick.Starr.StepCollisionDamage/';
import MedicalExpensesTugo from '../FastCover/Tugo.MedicalExpenses';
import StepOtherTugo from '../FastCover/Tugo.StepOther/';
import ADAndDBenefitsTugo from '../FastCover/Tugo.ADAndDBenefits/';
import BaggageAndPersonalItemsTravellerTugo from '../FastCover/Tugo.BaggageAndPersonalItemsTraveller/';
import RentalCarProtectionTravellerTugo from '../FastCover/Tugo.RentalCarProtectionTraveller/';
import StepOtherInsuranceCoverageTugo from '../FastCover/Tugo.StepOtherInsuranceCoverage/';
import StepBaseVictorsMedicalTugo from '../FastCover/Tugo.BaseVictorsMedical/';
import StudentMedicalBenefitsTugo from '../FastCover/Tugo.StudentMedicalBenefits/';
import StandardVTCMedicalBenefitsTugo from '../FastCover/Tugo.StandardVTCMedicalBenefits/';
import TravellerMedicalBenefitsTugo from '../FastCover/Tugo.TravellerMedicalBenefits/';
import OptimumMedicalBenefitsTugo from '../FastCover/Tugo.OptimumMedicalBenefits/';
import TripCancellationTugo from '../FastCover/Tugo.TripCancellation/';
import TripCancellationTravellerTugo from '../FastCover/Tugo.TripCancellationTraveller/';
import TripInterruptionTugo from '../FastCover/Tugo.TripInterruption/';
import SubmissionScreen from '../FastCover/StepDeclaration';
import FieldHeader from '../FastCover/components/FieldHeader/index';
import { setAuthenticationToken } from '../Login/actions';
import { setSelectedPolicyId } from '../App/actions';
import { LIST_POLICY_TYPE_CODE } from '../App/constants';
import {
  loadClaimFromSummary,
  updateSelectedClaimId,
  loadClaimList,
  downLoadSummary,
  updateSelectedClaimNumber,
  getShowElectronicConsent,
} from '../ClaimList/actions';
import { getClaimTypes } from '../FastCover/StepWhatHappened/actions';
import { changeLocale } from '../LanguageProvider/actions';
import { appLocales } from '../../i18n';
import saga from '../ClaimList/saga';
import stepWhatHappenedSaga from '../FastCover/StepWhatHappened/saga';
import {
  makeSelectClaimList,
  makeSelectClaimTypes,
  makeSelectDepreciationTypes,
} from '../ClaimList/selectors';
import {
  makeSelectClaimPaymentVersion,
  makeSelectShowElectronicConsentDocument,
  makeSelectJSONVersion,
  makeSelectInitClaimTypeList,
  makeSelectShowRequiredDocument,
  makeSelectShowZurichUHC,
  makeSelectClaimantId,
  makeSelectPolicyTypeCode,
  makeSelectPolicyPlanIds,
  makeSelectShowTrawickPaymentScreen,
} from '../App/selectors';
import reducer from '../ClaimList/reducer';
import stepWhatHappenedReducer from '../FastCover/StepWhatHappened/reducer';
import injectReducer from '../../utils/injectReducer';
import loginSaga from '../Login/saga';
import loginReducer from '../Login/reducer';
import injectSaga from '../../utils/injectSaga';
import ModalNotice from '../FastCover/StepDeclaration/components/ModalNotice';
import apiConfig from '../../utils/apiConfig';
import { makeSelectStepWhatHappened } from '../FastCover/StepWhatHappened/selectors';
import { makeSelectStepOther } from '../FastCover/StepOther/selectors';
import { makeSelectStepSupportingDocuments } from '../FastCover/StepSupportingDocuments/selectors';
import { makeSelectStepTripCancellationAndTripInterruption } from '../FastCover/StepTripCancellationAndTripInterruption/selectors';
import { makeSelectTripInterruptionTugo } from '../FastCover/Tugo.TripInterruption/selectors';
import tripInterruptionTugoReducer from '../FastCover/Tugo.TripInterruption/reducer';
import { makeSelectStepTripCancellationTugo } from '../FastCover/Tugo.TripCancellation/selectors';
import stepTripCancellationTugoReducer from '../FastCover/Tugo.TripCancellation/reducer';
import { makeSelectStepTripCancellationTravellerTugo } from '../FastCover/Tugo.TripCancellationTraveller/selectors';
import stepTripCancellationTravellerTugoReducer from '../FastCover/Tugo.TripCancellationTraveller/reducer';
import { makeSelectADAndDBenefitsTugo } from '../FastCover/Tugo.ADAndDBenefits/selectors';
import adAndDBenefitsTugoReducer from '../FastCover/Tugo.ADAndDBenefits/reducer';
import { makeSelectBaggageAndPersonalItemsTravellerTugo } from '../FastCover/Tugo.BaggageAndPersonalItemsTraveller/selectors';
import baggageAndPersonalItemsTravellerTugoReducer from '../FastCover/Tugo.BaggageAndPersonalItemsTraveller/reducer';
import { makeSelectRentalCarProtectionTravellerTugo } from '../FastCover/Tugo.RentalCarProtectionTraveller/selectors';
import rentalCarProtectionTravellerTugoReducer from '../FastCover/Tugo.RentalCarProtectionTraveller/reducer';
import { makeSelectStepOtherInsuranceCoverageTugo } from '../FastCover/Tugo.StepOtherInsuranceCoverage/selectors';
import stepOtherInsuranceCoverageTugoReducer from '../FastCover/Tugo.StepOtherInsuranceCoverage/reducer';
import { makeSelectStepDeclaration } from '../FastCover/StepDeclaration/selectors';
import { makeSelectStepClaimSummary } from '../FastCover/StepClaimSummary/selectors';
import { makeSelectOptimumMedicalBenefitsTugo } from '../FastCover/Tugo.OptimumMedicalBenefits/selectors';
import optimumMedicalBenefitsTugoReducer from '../FastCover/Tugo.OptimumMedicalBenefits/reducer';
import { makeSelectStandardVTCMedicalBenefitsTugo } from '../FastCover/Tugo.StandardVTCMedicalBenefits/selectors';
import standardVTCMedicalBenefitsTugoReducer from '../FastCover/Tugo.StandardVTCMedicalBenefits/reducer';
import { makeSelectTravellerMedicalBenefitsTugo } from '../FastCover/Tugo.TravellerMedicalBenefits/selectors';
import travellerMedicalBenefitsTugoReducer from '../FastCover/Tugo.TravellerMedicalBenefits/reducer';
import { makeSelectMedicalExpensesTugoStep } from '../FastCover/Tugo.MedicalExpenses/selectors';
import medicalExpensesTugoStepReducer from '../FastCover/Tugo.MedicalExpenses/reducer';
import { makeSelectStepOtherTugo } from '../FastCover/Tugo.StepOther/selectors';
import stepOtherTugoReducer from '../FastCover/Tugo.StepOther/reducer';
import { makeSelectBaseVictorsMedicalTugo } from '../FastCover/Tugo.BaseVictorsMedical/selectors';
import baseVictorsMedicalTugoReducer from '../FastCover/Tugo.BaseVictorsMedical/reducer';
import { makeSelectStudentMedicalBenefitsTugo } from '../FastCover/Tugo.StudentMedicalBenefits/selectors';
import studentMedicalBenefitsTugoReducer from '../FastCover/Tugo.StudentMedicalBenefits/reducer';
import {
  stepSnowSportsExpenseLookup,
  stepOtherExpenseLookup,
  stepTripCancellationAndTripInterruptionExpenseLookup,
  stepBaggageAndPersonalItemsExpenseLookup,
  stepMedicalExpensesExpenseLookup,
  stepCancellationAdditionalExpenseLookup,
  stepPersonalItemsExpenseLookup,
  stepOverseasMedicalExpenseLookup,
  stepRentalVehicleExpenseLookup,
  stepPetMedicalExpenseLookup,
  stepCollisionDamageExpenseLookup,
  stepPropertyDamageExpenseLookup,
  stepMedicalExpenseLookup,
  stepTripCancellationLookup,
  stepTripInterruptionLookup,
  stepTripDelayLookup,
  stepMissedConnectionLookup,
  stepAccidentalDeathAndDismembermentLookup,
  stepBaggageAndPersonalLookup,
  stepSportsEquipmentLookup,
  stepMedicalExpenseCFLookup,
  stepTripCancellationCFLookup,
  baggagePersonalEffectsLookup,
  itineraryChangeLookup,
  medicalHardshipLookup,
  jobLossHardshipLookup,
  disasterAssistanceHardshipLookup,
  stepTravelDelayLookup,
  stepMedicalAndEvacuationLookup,
  stepChangesToYourJourneyLookup,
  stepBaggageAndPersonalItemsSCTILookup,
  stepPersonalAccidentSCTILookup,
  stepRentalVehicleExcessSCTILookup,
  stepCashBankCardsTravelDocumentsAndPassportsLookup,
  stepChangesToYourJourneyTrawickLookup,
  stepBaggageAndPersonalItemsStarrLookup,
  stepOtherStarrLookup,
  stepCollisionDamageStarrLookup,
  stepMedicalExpensesTugoLookup,
  stepOtherTugoLookup,
  stepBaseVictorsMedicalTugoLookup,
  stepStudentMedicalBenefitsTugoLookup,
  stepStandardVTCMedicalBenefitsTugoLookup,
  stepTravellerMedicalBenefitsTugoLookup,
  stepOptimumMedicalBenefitsTugoLookup,
  stepTripCancellationTugoLookup,
  stepTripCancellationTravellerTugoLookup,
  stepTripInterruptionTugoLookup,
  stepTripInterruptionTravellerTugoLookup,
  stepADAndDTugoLookup,
  stepBaggageAndPersonalItemsTravellerTugoLookup,
  stepOtherInsuranceCoverageTugoLookup,
  stepRentalCarProtectionTravellerTugoLookup,
} from '../FastCover/dataMapper/claimCodeMapper';
import { makeDirty, makeError, makeValid } from '../Wizard/actions';
class SummaryScreen extends React.Component {
  constructor(props) {
    super(props);
    const { showZurichUHC } = this.props;
    this.state = {
      exporting: false,
      notice: false,
      claimNo: '',
      sections: [
        {
          id: 3,
          title: messages.section4,
          component: StepWhatHappened,
        },
        {
          id: 6,
          title: messages.section7,
          component: StepOverseasMedical,
        },
        {
          id: 5,
          title: messages.section6,
          component: StepPersonalItems,
        },
        {
          id: 4,
          title: messages.section5,
          component: StepCancellationAdditional,
        },
        {
          id: 7,
          title: messages.section8,
          component: StepRentalVehicle,
        },
        {
          id: 8,
          title: messages.section9,
          component: StepSnowSports,
        },
        {
          id: 20,
          title: showZurichUHC ? messages.sectionMedicalExpenseZurichStep : messages.section20,
          component: showZurichUHC ? MedicalExpenseZurichStep : StepMedicalExpenses,
        },
        {
          id: 18,
          title: messages.section18,
          component: StepTripCancellationAndTripInterruption,
        },
        {
          id: 19,
          title: messages.section19,
          component: StepBaggageAndPersonalItems,
        },
        {
          id: 9,
          title: messages.section10,
          component: StepOther,
        },
        // new screen
        {
          id: 16,
          title: messages.sectionPetMedicalStep,
          component: PetMedicalStep,
        },
        {
          id: 17,
          title: messages.sectionCollisionDamageStep,
          component: CollisionDamageStep,
        },
        {
          id: 21,
          title: messages.sectionPropertyDamage,
          component: PropertyDamageStep,
        },
        {
          id: 22,
          title: messages.sectionTripCancellation,
          component: TripCancellationStep,
        },
        {
          id: 23,
          title: messages.sectionMedicalExpenseStep,
          component: MedicalExpenseStep,
        },
        {
          id: 24,
          title: messages.sectionAccidentalDeathAndDismemberment,
          component: AccidentalDeathAndDismemberment,
        },
        {
          id: 25,
          title: messages.sectionTripDelayStep,
          component: TripDelayStep,
        },
        {
          id: 26,
          title: messages.sectionTripInterruptionStep,
          component: TripInterruptionStep,
        },
        {
          id: 27,
          title: messages.sectionMissedConnectionStep,
          component: MissedConnectionStep,
        },
        {
          id: 28,
          title: messages.sectionBaggageAndPersonalStep,
          component: BaggageAndPersonalStep,
        },
        {
          id: 29,
          title: messages.sectionSportsEquipmentStep,
          component: SportsEquipmentStep,
        },
        // {
        //   id: 30,
        //   title: messages.sectionMedicalHardshipStep,
        //   component: MedicalHardshipStep,
        // },
        // {
        //   id: 31,
        //   title: messages.sectionJobLossHardshipStep,
        //   component: JobLossHardshipStep,
        // },
        {
          id: 32,
          title: messages.sectionMedicalExpenseCFStep,
          component: MedicalExpenseCFStep,
        },
        {
          id: 33,
          title: messages.sectionTripCancellationCFStep,
          component: TripCancellationCFStep,
        },
        {
          id: 34,
          title: messages.sectionBaggagePersonalEffects,
          component: BaggagePersonalEffects,
        },
        {
          id: 35,
          title: messages.sectionItineraryChange,
          component: ItineraryChange,
        },
        {
          id: 36,
          title: messages.sectionTravelDelay,
          component: StepTravelDelay,
        },
        {
          id: 37,
          title: messages.sectionMedicalAndEvacuationSCTI,
          component: MedicalAndEvacuationSCTIStep,
        },
        {
          id: 38,
          title: messages.sectionChangesToYourJourneySCTI,
          component: ChangesToYourJourneySCTIStep,
        },
        {
          id: 39,
          title: messages.sectionBaggageAndPersonalItemsSCTI,
          component: BaggageAndPersonalItemsSCTIStep,
        },
        {
          id: 40,
          title: messages.sectionPersonalAccidentSCTI,
          component: PersonalAccidentSCTIStep,
        },
        {
          id: 41,
          title: messages.sectionRentalVehicleExcessSCTI,
          component: RentalVehicleExcessSCTIStep,
        },
        {
          id: 42,
          title: messages.sectionCashBankCardsTravelDocumentsAndPassports,
          component: CashBankCardsTravelDocumentsAndPassportsStep,
        },
        {
          id: 43,
          title: messages.sectionChangesToYourJourney,
          component: ChangesToYourJourneyStep,
        },
        {
          id: 44,
          title: messages.sectionBaggageAndPersonalItemsStarr,
          component: BaggageAndPersonalItemsStarrStep,
        },
        {
          id: 45,
          title: messages.sectionOtherStarr,
          component: StepOtherStarr,
        },
        {
          id: 46,
          title: messages.sectionCollisionDamageStarr,
          component: CollisionDamageStarrStep,
        },
        {
          id: 47,
          title: messages.sectionMedicalExpensesTugo,
          component: MedicalExpensesTugo,
        },
        {
          id: 48,
          title: messages.sectionOtherTugo,
          component: StepOtherTugo,
        },
        {
          id: 53,
          title: messages.sectionStandardVTCMedicalBenefitsTugo,
          component: StandardVTCMedicalBenefitsTugo,
        },
        {
          id: 61,
          title: messages.sectionTravellerMedicalBenefitsTugo,
          component: TravellerMedicalBenefitsTugo,
        },
        {
          id: 60,
          title: messages.sectionOptimumMedicalBenefitsTugo,
          component: OptimumMedicalBenefitsTugo,
        },
        {
          id: 49,
          title: messages.sectionBaseVictorsMedicalTugo,
          component: StepBaseVictorsMedicalTugo,
        },
        {
          id: 50,
          title: messages.sectionStudentMedicalBenefitsTugo,
          component: StudentMedicalBenefitsTugo,
        },
        {
          id: 54,
          title: messages.sectionTripCancellationTugo,
          component: TripCancellationTugo,
        },
        {
          id: 51,
          title: messages.sectionTripInterruptionTugo,
          component: TripInterruptionTugo,
        },
        {
          id: 52,
          title: messages.sectionADAndDBenefitsTugo,
          component: ADAndDBenefitsTugo,
        },
        {
          id: 63,
          title: messages.sectionBaggageAndPersonalItemsTravellerTugo,
          component: BaggageAndPersonalItemsTravellerTugo,
        },
        {
          id: 64,
          title: messages.sectionRentalCarProtectionTravellerTugo,
          component: RentalCarProtectionTravellerTugo,
        },
        {
          id: 62,
          title: messages.sectionOtherInsuranceCoverageTugo,
          component: StepOtherInsuranceCoverageTugo,
        },
        {
          id: 10,
          title: messages.section11,
          component: StepSupportingDocuments,
        },
        {
          id: 2,
          title: appConfig.showANZPayment === true ? messages.section2 : apiConfig.enableNewPaymentScreen === true ? messages.section2 : messages.section21,
          component: appConfig.showANZPayment === true ? StepAppsureBankDetails : apiConfig.enableNewPaymentScreen === true ? StepAppsureBankDetails : StepPaymentDetails,
        },
        {
          id: 15,
          title: messages.section15,
          component: StepClaimSummary,
        },
        {
          id: 11,
          title: messages.readyToSubmit,
          component: SubmissionScreen,
        },
      ],
    };
  }

  componentDidMount() {
    const { params } = this.props.match || {};
    this.props.onRequestClaimJson(params);
    this.props.loadClaimList();
    // this.props.getClaimTypes();

    // Check for locale query parameter and set language if valid
    if (this.props.location && this.props.location.search) {
      const urlParams = new URLSearchParams(this.props.location.search);
      const localeParam = urlParams.get('locale');
      if (localeParam && appLocales.includes(localeParam)) {
        this.props.onChangeLocale(localeParam);
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.claim &&
      nextProps.claim.claims &&
      nextProps.claim.claims.length
    ) {
      const { params } = this.props.match || {};
      const res = _.find(
        nextProps.claim.claims,
        (i) => i.claimParentId.toString() === params.claimNumber
      );
      const claimNumber = res === undefined ? params.claimNumber : res.claimNumber;
      this.setState({ claimNo: claimNumber });
      this.props.updateSelectedClaimNumber(claimNumber);
    }

    // Check for locale query parameter change
    if (nextProps.location && nextProps.location.search) {
      const urlParams = new URLSearchParams(nextProps.location.search);
      const localeParam = urlParams.get('locale');
      if (localeParam && appLocales.includes(localeParam)) {
        const currentUrlParams = this.props.location && this.props.location.search
          ? new URLSearchParams(this.props.location.search)
          : null;
        const currentLocaleParam = currentUrlParams ? currentUrlParams.get('locale') : null;
        if (localeParam !== currentLocaleParam) {
          this.props.onChangeLocale(localeParam);
        }
      }
    }
  }

  showModal = () => {
    this.setState({ notice: true });
  };

  closeModal = () => {
    this.setState({ notice: false });
  };

  exportPdf = () => {
    this.setState({ exporting: true });
    this.showModal();
    const cb = () => {
      this.setState({ exporting: false });
      this.closeModal();
    };
    this.props.downLoadSummary(cb);
  };

  renderCollapsibleHeader = (message) => <FormattedMessage {...message} />;

  render() {
    const { notice, claimNo, sections } = this.state;
    const { params } = this.props.match || {};
    const { selectedBenefits } = this.props.form;
    const {
      claim,
      showElectronicConsentDocument,
      jsonVersion,
      showZurichUHC,
      policyTypeCode,
      policyPlanIds,
      claimTypes,
    } = this.props;
    const { emailAddress } = this.props.stepDeclarationData;
    let selected =
      !!selectedBenefits && typeof selectedBenefits.toJS === 'function'
        ? selectedBenefits.toJS()
        : selectedBenefits || [];

    // Apply the same policyPlanIds benefit-visibility rules used in StepWhatHappened
    // so the Summary screen doesn't render benefits not covered by the selected plans.
    const normalizedPolicyPlanIds = Array.isArray(policyPlanIds)
      ? policyPlanIds
      : (policyPlanIds && typeof policyPlanIds.toJS === 'function'
        ? policyPlanIds.toJS()
        : []);

    const hasAnyTugoPlanId =
      normalizedPolicyPlanIds.some((planId) =>
        LIST_POLICY_TYPE_CODE.LIST_POLICY_PLAN_ID_TUGO_BENEFIT_TILES.includes(planId)
      ) || LIST_POLICY_TYPE_CODE.LIST_POLICY_PLAN_ID_TUGO_BENEFIT_TILES.includes(policyTypeCode);

    // AD&D Benefits (TUGO) visibility in Summary depends on both `selectedBenefits`
    // and the step-level questionnaire data (`stepADAndDBenefitsTugoData`).
    // Filter the step data as well to avoid rendering "ghost" AD&D rows/doc items
    // when the selected policy plans do not include AD&D benefits.
    const hasADAndDPlan =
      normalizedPolicyPlanIds.some((planId) =>
        LIST_POLICY_TYPE_CODE.LIST_POLICY_PLAN_ID_SHOW_AD_AND_D.includes(planId)
      ) || LIST_POLICY_TYPE_CODE.LIST_POLICY_PLAN_ID_SHOW_AD_AND_D.includes(policyTypeCode);

    const includesAnyStudentPlan =
      normalizedPolicyPlanIds.some((planId) => LIST_POLICY_TYPE_CODE.LIST_POLICY_TYPE_CODE_STUDENT.includes(planId)) ||
      LIST_POLICY_TYPE_CODE.LIST_POLICY_TYPE_CODE_STUDENT.includes(policyTypeCode);

    const includesAnyStandardVtcMedicalPlan =
      normalizedPolicyPlanIds.some((planId) => LIST_POLICY_TYPE_CODE.LIST_POLICY_TYPE_CODE_STANDARD_VTC.includes(planId)) ||
      LIST_POLICY_TYPE_CODE.LIST_POLICY_TYPE_CODE_STANDARD_VTC.includes(policyTypeCode);

    const includesAnyTravellerMedicalPlan =
      normalizedPolicyPlanIds.some((planId) => LIST_POLICY_TYPE_CODE.LIST_POLICY_TYPE_CODE_TRAVELLER.includes(planId)) ||
      LIST_POLICY_TYPE_CODE.LIST_POLICY_TYPE_CODE_TRAVELLER.includes(policyTypeCode);

    const includesAnyOptimumMedicalPlan =
      normalizedPolicyPlanIds.some((planId) => LIST_POLICY_TYPE_CODE.LIST_POLICY_TYPE_CODE_OPTIMUM.includes(planId)) ||
      LIST_POLICY_TYPE_CODE.LIST_POLICY_TYPE_CODE_OPTIMUM.includes(policyTypeCode);

    const includesAnyOtherBenefitNbaPlan =
      normalizedPolicyPlanIds.some((planId) => LIST_POLICY_TYPE_CODE.LIST_POLICY_TYPE_CODE_OTHER_BENEFIT_NBA.includes(planId)) ||
      LIST_POLICY_TYPE_CODE.LIST_POLICY_TYPE_CODE_OTHER_BENEFIT_NBA.includes(policyTypeCode);

    // The medical-benefit plan lists overlap (e.g. PL-SMED-21/PL-SMED-22 are in both
    // Standard VTC and Traveller), so a single winning benefit type must be resolved with
    // the same priority the wizard uses (see wizardStepMapper: Standard VTC > Traveller >
    // Optimum > Student). Without this, a VTC claim would satisfy both the VTC and Traveller
    // gates and render both "Medical Benefits" and "Traveller Medical Benefits".
    const isStandardVtcMedicalExclusive = includesAnyStandardVtcMedicalPlan;
    const isTravellerMedicalExclusive =
      !includesAnyStandardVtcMedicalPlan && includesAnyTravellerMedicalPlan;
    const isOptimumMedicalExclusive =
      !includesAnyStandardVtcMedicalPlan &&
      !includesAnyTravellerMedicalPlan &&
      includesAnyOptimumMedicalPlan;
    const isStudentMedicalExclusive =
      !includesAnyStandardVtcMedicalPlan &&
      !includesAnyTravellerMedicalPlan &&
      !includesAnyOptimumMedicalPlan &&
      includesAnyStudentPlan;

    const hasTripInterruptionPlan =
      normalizedPolicyPlanIds.some((planId) =>
        LIST_POLICY_TYPE_CODE.LIST_POLICY_PLAN_ID_SHOW_TRIP_INTERRUPTION.includes(planId)
      ) || LIST_POLICY_TYPE_CODE.LIST_POLICY_PLAN_ID_SHOW_TRIP_INTERRUPTION.includes(policyTypeCode);

    const hasTripCancellationPlan =
      normalizedPolicyPlanIds.some((planId) =>
        LIST_POLICY_TYPE_CODE.LIST_POLICY_PLAN_ID_SHOW_TRIP_CANCELLATION.includes(planId)
      ) || LIST_POLICY_TYPE_CODE.LIST_POLICY_PLAN_ID_SHOW_TRIP_CANCELLATION.includes(policyTypeCode);

    // Trip Cancellation has two variants captured under separate Redux slices in FNOL:
    // `Tugo.TripCancellation` (stepTripCancellationTugo) and `Tugo.TripCancellationTraveller`
    // (stepTripCancellationTravellerTugo). The Summary screen must render the same variant the
    // wizard used (see wizardStepMapper `isTripCancellationTravellerPolicy`) so the entered
    // "Changes to your journey" expenses are read from the slice that actually holds the data.
    const isTripCancellationTravellerPolicy =
      LIST_POLICY_TYPE_CODE.LIST_POLICY_TYPE_CODE_TRIP_CANCELLATION_TRAVELLER.includes(policyTypeCode) ||
      normalizedPolicyPlanIds.some((planId) =>
        LIST_POLICY_TYPE_CODE.LIST_POLICY_TYPE_CODE_TRIP_CANCELLATION_TRAVELLER.includes(planId)
      );

    // Fallback: if the loaded claim already has data in the Traveller trip-cancellation slice,
    // render the Traveller variant regardless of policy-code detection (policyTypeCode/policyPlanIds
    // may not resolve to the Traveller list in the Summary context).
    const tripCancellationTravellerData = this.props.stepTripCancellationTravellerTugoData || {};
    const tripCancellationTravellerExpenses = tripCancellationTravellerData.whatExpensesAreYouClaimingFor;
    const hasTripCancellationTravellerData =
      !!(tripCancellationTravellerExpenses && (tripCancellationTravellerExpenses.length || tripCancellationTravellerExpenses.size)) ||
      !!tripCancellationTravellerData.cancelledBeforeLeaving ||
      !!tripCancellationTravellerData.changedAfterLeaving;
    const useTripCancellationTravellerVariant = isTripCancellationTravellerPolicy || hasTripCancellationTravellerData;

    let stepADAndDBenefitsTugoData = this.props.stepADAndDBenefitsTugoData;
    if (hasAnyTugoPlanId && !hasADAndDPlan && stepADAndDBenefitsTugoData) {
      stepADAndDBenefitsTugoData = {
        ...stepADAndDBenefitsTugoData,
        whatExpensesAreYouClaimingFor: [],
        airFlightCommonCarrierAccidentItems: [],
        accident24HourItems: [],
        accidentalDeathAndDismembermentParentSelected: false,
      };
    }

    let stepTripInterruptionTugoData = this.props.stepTripInterruptionTugoData;
    if (hasAnyTugoPlanId && !hasTripInterruptionPlan && stepTripInterruptionTugoData) {
      // `stepTripInterruptionTugoDataMapper` has special logic that can return results
      // based on form selections even when `selectedBenefits` is filtered out.
      // Clearing these fields prevents that output for disallowed plans.
      stepTripInterruptionTugoData = {
        ...(typeof stepTripInterruptionTugoData === 'object' ? stepTripInterruptionTugoData : {}),
        expenseTypesClaiming: [],
        travelInterruption: 'false',
        lossInformationItems: [],
      };
    }

    let stepTripCancellationTugoData = this.props.stepTripCancellationTugoData;
    if (hasAnyTugoPlanId && !hasTripCancellationPlan && stepTripCancellationTugoData) {
      stepTripCancellationTugoData = {
        ...(typeof stepTripCancellationTugoData === 'object' ? stepTripCancellationTugoData : {}),
        whatExpensesAreYouClaimingFor: [],
        healthSubQuestions: [],
        pregnancyAdoptionSubQuestions: [],
        employmentEducationSubQuestions: [],
        legalIssuesSubQuestions: [],
        carrierAccidentWeatherSubQuestions: [],
        otherReasonsSubQuestions: [],
      };
    }

    if (hasAnyTugoPlanId && !!claimTypes) {
      let claimTypeList =
        !!claimTypes && typeof claimTypes.toJS === 'function'
          ? claimTypes.toJS()
          : claimTypes;

      // Only filter once we have a populated claimType list; otherwise leave `selected` untouched
      // to avoid hiding all sections during async loads.
      if (Array.isArray(claimTypeList) && claimTypeList.length > 0) {
        const hasMedicalBenefitsPlan =
          normalizedPolicyPlanIds.some(
            (planId) =>
              LIST_POLICY_TYPE_CODE.LIST_POLICY_PLAN_ID_SHOW_MEDICAL_BENEFITS.includes(planId) ||
              LIST_POLICY_TYPE_CODE.LIST_POLICY_TYPE_CODE_STUDENT.includes(planId)
          ) ||
          LIST_POLICY_TYPE_CODE.LIST_POLICY_PLAN_ID_SHOW_MEDICAL_BENEFITS.includes(policyTypeCode) ||
          LIST_POLICY_TYPE_CODE.LIST_POLICY_TYPE_CODE_STUDENT.includes(policyTypeCode);
        // re-use computed plan-gating (independent from claimTypes)
        const effectiveHasADAndDPlan = hasADAndDPlan;

        if (!hasMedicalBenefitsPlan) {
          claimTypeList = claimTypeList.filter((x) =>
            x.description !== 'Medical Benefits' &&
            x.description !== 'Medical Expenses' &&
            x.description !== 'Medical Expenses - Visitors to Canada' &&
            x.description !== 'Student Medical Benefits'
          );
        }
        if (!hasTripCancellationPlan) {
          claimTypeList = claimTypeList.filter((x) => x.description !== 'Changes to your journey');
        }
        if (!hasTripInterruptionPlan) {
          claimTypeList = claimTypeList.filter((x) => x.description !== 'Trip Interruption');
        }
        if (!effectiveHasADAndDPlan) {
          claimTypeList = claimTypeList.filter((x) => x.description !== 'AD&D');
        }

        const allowedBenefitClaimCodes = _.uniq(
          _.flatten(
            claimTypeList.map((x) => x.codeList || [])
          )
        );

        // Policy API `codeList` can be incomplete when multiple plan IDs exist.
        // Preserve selected TUGO benefits that match the selected plan IDs.
        const tugoClaimCodesFromPlanIds = _.uniq(
          _.flatten([
            includesAnyStudentPlan ? stepStudentMedicalBenefitsTugoLookup.claimCodeList : [],
            includesAnyStandardVtcMedicalPlan ? stepStandardVTCMedicalBenefitsTugoLookup.claimCodeList : [],
            includesAnyTravellerMedicalPlan ? stepTravellerMedicalBenefitsTugoLookup.claimCodeList : [],
            includesAnyOptimumMedicalPlan ? stepOptimumMedicalBenefitsTugoLookup.claimCodeList : [],
            includesAnyOtherBenefitNbaPlan ? stepBaseVictorsMedicalTugoLookup.claimCodeList : [],
            hasTripInterruptionPlan ? stepTripInterruptionTugoLookup.claimCodeList : [],
            hasTripInterruptionPlan ? stepTripInterruptionTravellerTugoLookup.claimCodeList : [],
            hasTripCancellationPlan ? stepTripCancellationTugoLookup.claimCodeList : [],
            hasTripCancellationPlan ? stepTripCancellationTravellerTugoLookup.claimCodeList : [],
          ])
        );

        // Apply planId rules to the selected benefits.
        selected = selected.filter(
          (benefit) =>
            allowedBenefitClaimCodes.includes(benefit.claimCode) ||
            tugoClaimCodesFromPlanIds.includes(benefit.claimCode)
        );
      }
    }

    // Pass the filtered selectedBenefits into all summary steps (e.g. StepClaimSummary)
    // so both rendering and calculations respect policyPlanIds.
    const stepWhatHappenedData = {
      ...this.props.form,
      selectedBenefits: selected,
    };
    const errorEmails = null;

    // Check if claimTypes from API contain any Traveller medical code (same logic as wizardStepMapper)
    const claimTypeListForStepCheck = !!claimTypes && typeof claimTypes.toJS === 'function' ? claimTypes.toJS() : (claimTypes || []);
    const apiClaimCodes = Array.isArray(claimTypeListForStepCheck) ? claimTypeListForStepCheck.map((x) => x.claimCode) : [];
    const hasTravellerMedicalInClaimTypes = includesAnyTravellerMedicalPlan && _.intersection(stepTravellerMedicalBenefitsTugoLookup.claimCodeList, apiClaimCodes).length > 0;

    // Update for ShowTrawickFNOLRefactoring
    const newVersion = jsonVersion > 11;
    const newVersionForOtherCollision = jsonVersion > 12;

    let stepTravelDelayList = stepTravelDelayLookup.claimCodeList;
    let stepTripCancellationAndTripInterruptionExpenseList = stepTripCancellationAndTripInterruptionExpenseLookup.claimCodeList;
    let stepChangesToYourJourneyTrawickList = stepChangesToYourJourneyTrawickLookup.claimCodeList;
    // Medical Expenses
    let stepMedicalExpensesList = stepMedicalExpensesExpenseLookup.claimCodeList;
    let stepMedicalExpensesTrawickList = stepMedicalExpenseCFLookup.claimCodeList;
    // Baggage and Personal Items
    let stepBaggageAndPersonalItemsList = stepBaggageAndPersonalItemsExpenseLookup.claimCodeList;
    let stepBaggageAndPersonalItemsStarrList = stepBaggageAndPersonalItemsStarrLookup.claimCodeList;
    // Other
    let stepOtherClaimCodeList = stepOtherExpenseLookup.claimCodeList;
    let stepOtherStarrList = stepOtherStarrLookup.claimCodeList;
    // Collision Damage
    let stepCollisionDamageList = stepCollisionDamageExpenseLookup.claimCodeList;
    let stepCollisionDamageStarrList = stepCollisionDamageStarrLookup.claimCodeList;

    // Update lists based on jsonVersion
    if (newVersion) { // jsonVersion > 11
      stepMedicalExpensesList = stepMedicalExpensesList.filter((x) => !stepMedicalExpensesTrawickList.includes(x));
      stepTravelDelayList = stepTravelDelayList.filter((x) => !stepChangesToYourJourneyTrawickList.includes(x));
      stepTripCancellationAndTripInterruptionExpenseList = stepTripCancellationAndTripInterruptionExpenseList.filter((x) => !stepChangesToYourJourneyTrawickList.includes(x));
    } else {
      stepChangesToYourJourneyTrawickList = stepChangesToYourJourneyTrawickList.filter((x) => !stepTravelDelayList.includes(x) && !stepTripCancellationAndTripInterruptionExpenseList.includes(x));
      stepMedicalExpensesTrawickList = stepMedicalExpensesTrawickList.filter((x) => !stepMedicalExpensesList.includes(x));
    }

    // Update lists based on jsonVersion
    if (newVersionForOtherCollision) { // jsonVersion > 12
      stepBaggageAndPersonalItemsList = stepBaggageAndPersonalItemsList.filter((x) => !stepBaggageAndPersonalItemsStarrList.includes(x));
      stepOtherClaimCodeList = stepOtherClaimCodeList.filter((x) => !stepOtherStarrList.includes(x));
      stepCollisionDamageList = stepCollisionDamageList.filter((x) => !stepCollisionDamageStarrList.includes(x));
    } else {
      stepBaggageAndPersonalItemsStarrList = stepBaggageAndPersonalItemsStarrList.filter((x) => !stepBaggageAndPersonalItemsList.includes(x));
      stepOtherStarrList = stepOtherStarrList.filter((x) => !stepOtherClaimCodeList.includes(x));
      stepCollisionDamageStarrList = stepCollisionDamageStarrList.filter((x) => !stepCollisionDamageList.includes(x));
    }

    return (
      <div className="summary_tbl_wrapper">
        <table
          style={{ marginTop: 20, marginBottom: 20 }}
          className="report-container"
        >
          <thead className="report-header">
            <tr>
              <td>
                <div
                  className="header-info"
                  style={{ textAlign: 'right', height: '70px' }}
                >
                  <img id="headerLogo" className="logo" width={'175px'} alt="Header Logo" />
                </div>
              </td>
            </tr>
          </thead>
          <tbody className="report-content">
            <tr>
              <td className="report-content-cell">
                <div style={{ overflow: 'hidden' }}>
                  <FieldHeader>
                    <FormattedMessage {...messages.sectionTitle} />
                  </FieldHeader>
                  {sections.map((section, index) => {
                    if (selected.length) {
                      if (
                        section.id === 4 &&
                        !_.intersection(
                          stepCancellationAdditionalExpenseLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 5 &&
                        !_.intersection(
                          stepPersonalItemsExpenseLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 6 &&
                        !_.intersection(
                          stepOverseasMedicalExpenseLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 7 &&
                        !_.intersection(
                          stepRentalVehicleExpenseLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 8 &&
                        !_.intersection(
                          stepSnowSportsExpenseLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 9 &&
                        !_.intersection(
                          stepOtherClaimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 18 &&
                        !_.intersection(
                          stepTripCancellationAndTripInterruptionExpenseList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 19 &&
                        !_.intersection(
                          stepBaggageAndPersonalItemsList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 20 &&
                        !_.intersection(
                          stepMedicalExpensesList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 16 &&
                        !_.intersection(
                          stepPetMedicalExpenseLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 17 &&
                        !_.intersection(
                          stepCollisionDamageList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 21 &&
                        !_.intersection(
                          stepPropertyDamageExpenseLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 22 &&
                        !_.intersection(
                          stepTripCancellationLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 23 &&
                        !_.intersection(
                          stepMedicalExpenseLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 24 &&
                        !_.intersection(
                          stepAccidentalDeathAndDismembermentLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 25 &&
                        !_.intersection(
                          stepTripDelayLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 26 &&
                        !_.intersection(
                          stepTripInterruptionLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 27 &&
                        !_.intersection(
                          stepMissedConnectionLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 28 &&
                        !_.intersection(
                          stepBaggageAndPersonalLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 29 &&
                        !_.intersection(
                          stepSportsEquipmentLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 32 &&
                        !_.intersection(
                          stepMedicalExpensesTrawickList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 33 &&
                        !_.intersection(
                          stepTripCancellationCFLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 34 &&
                        !_.intersection(
                          baggagePersonalEffectsLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 35 &&
                        !_.intersection(
                          itineraryChangeLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 33 &&
                        !_.intersection(
                          medicalHardshipLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 34 &&
                        !_.intersection(
                          jobLossHardshipLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 35 &&
                        !_.intersection(
                          disasterAssistanceHardshipLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 36 &&
                        !_.intersection(
                          stepTravelDelayList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 37 &&
                        !_.intersection(
                          stepMedicalAndEvacuationLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 38 &&
                        !_.intersection(
                          stepChangesToYourJourneyLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 39 &&
                        !_.intersection(
                          stepBaggageAndPersonalItemsSCTILookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 40 &&
                        !_.intersection(
                          stepPersonalAccidentSCTILookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 41 &&
                        !_.intersection(
                          stepRentalVehicleExcessSCTILookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 42 &&
                        !_.intersection(
                          stepCashBankCardsTravelDocumentsAndPassportsLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 43 &&
                        !_.intersection(
                          stepChangesToYourJourneyTrawickList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 44 &&
                        !_.intersection(
                          stepBaggageAndPersonalItemsStarrList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 45 &&
                        !_.intersection(
                          stepOtherStarrList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 46 &&
                        !_.intersection(
                          stepCollisionDamageStarrList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 47 &&
                        !_.intersection(
                          stepMedicalExpensesTugoLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 48 &&
                        !_.intersection(
                          stepOtherTugoLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 49 &&
                        (!includesAnyOtherBenefitNbaPlan || !_.intersection(
                          stepBaseVictorsMedicalTugoLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length)
                      ) {
                        return null;
                      }
                      if (
                        section.id === 50 &&
                        (!isStudentMedicalExclusive || !_.intersection(
                          stepStudentMedicalBenefitsTugoLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length)
                      ) {
                        return null;
                      }
                      if (
                        section.id === 51 &&
                        !_.intersection(
                          [...stepTripInterruptionTugoLookup.claimCodeList, ...stepTripInterruptionTravellerTugoLookup.claimCodeList],
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 52 &&
                        !_.intersection(
                          (stepADAndDTugoLookup && stepADAndDTugoLookup.claimCodeList) || [],
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 54 &&
                        !_.intersection(
                          stepTripCancellationTugoLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length &&
                        !_.intersection(
                          stepTripCancellationTravellerTugoLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 53 &&
                        (!isStandardVtcMedicalExclusive || !_.intersection(
                          stepStandardVTCMedicalBenefitsTugoLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length)
                      ) {
                        return null;
                      }
                      if (
                        section.id === 61 &&
                        (!isTravellerMedicalExclusive || (!hasTravellerMedicalInClaimTypes && !_.intersection(
                          stepTravellerMedicalBenefitsTugoLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length))
                      ) {
                        return null;
                      }
                      if (
                        section.id === 60 &&
                        (!isOptimumMedicalExclusive || !_.intersection(
                          stepOptimumMedicalBenefitsTugoLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length)
                      ) {
                        return null;
                      }
                      if (
                        section.id === 63 &&
                        !_.intersection(
                          stepBaggageAndPersonalItemsTravellerTugoLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 64 &&
                        !_.intersection(
                          stepRentalCarProtectionTravellerTugoLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 62 &&
                        !_.intersection(
                          stepOtherInsuranceCoverageTugoLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                    }
                    if (section.id === 20 && showZurichUHC) {
                      section.component = MedicalExpenseZurichStep;
                      section.title = messages.sectionMedicalExpenseZurichStep;
                    }
                    if (section.id === 54) {
                      section.component = useTripCancellationTravellerVariant
                        ? TripCancellationTravellerTugo
                        : TripCancellationTugo;
                    }
                    const Component = section.component;
                    return (
                      <div
                        key={index}
                        className={'pheader'}
                      >
                        {index === 0 && (
                          <div
                            className="text-center font-weight-bold mb-3 showOnPrint"
                            style={{ fontSize: 24 }}
                          >
                            <span>{claim.cellcaptive} Travel Claim Summary - </span>
                            <span>{claimNo}</span>
                          </div>
                        )}
                        <Collapsible
                          trigger={this.renderCollapsibleHeader(section.title)}
                          key={section.id}
                          open={index === 0}
                        >
                          <div>
                            <Component
                              summaryClaimNo={claimNo}
                              policyNumber={params.policyNumber}
                              token={this.props.match.params.token}
                              isSummary
                              signature
                              submitted
                              handleChange={() => { }}
                              {...this.props}
                              claimTypes={this.props.claimTypes}
                              stepWhatHappenedData={stepWhatHappenedData}
                              stepOtherData={this.props.stepOtherData}
                              stepSupportingDocumentsData={this.props.stepSupportingDocumentsData}
                              stepTripCancellationAndTripInterruptionData={this.props.stepTripCancellationAndTripInterruptionData}
                              stepTripInterruptionTugoData={this.props.stepTripInterruptionTugoData}
                              stepTripCancellationTugoData={this.props.stepTripCancellationTugoData}
                              stepOptimumMedicalBenefitsTugoData={this.props.stepOptimumMedicalBenefitsTugoData}
                              stepStandardVTCMedicalBenefitsTugoData={this.props.stepStandardVTCMedicalBenefitsTugoData}
                              stepTravellerMedicalBenefitsTugoData={this.props.stepTravellerMedicalBenefitsTugoData}
                              stepMedicalExpensesTugoData={this.props.stepMedicalExpensesTugoData}
                              stepOtherTugoData={this.props.stepOtherTugoData}
                              stepBaseVictorsMedicalTugoData={this.props.stepBaseVictorsMedicalTugoData}
                              stepStudentMedicalBenefitsTugoData={this.props.stepStudentMedicalBenefitsTugoData}
                              stepADAndDBenefitsTugoData={this.props.stepADAndDBenefitsTugoData}
                              stepBaggageAndPersonalItemsTravellerTugoData={this.props.stepBaggageAndPersonalItemsTravellerTugoData}
                              stepRentalCarProtectionTravellerTugoData={this.props.stepRentalCarProtectionTravellerTugoData}
                              stepOtherInsuranceCoverageTugoData={this.props.stepOtherInsuranceCoverageTugoData}
                              showElectronicConsentDocument={showElectronicConsentDocument}
                              electronicConsentDocument
                              handleDownload={() => { }}
                              emailAddress={emailAddress}
                              errorEmails={errorEmails}
                              jsonVersion={jsonVersion}
                              claimTypesInit={this.props.claimTypesInit}
                              showRequiredDocument={this.props.showRequiredDocument}
                              showZurichUHC={this.props.showZurichUHC}
                              claimantId={this.props.claimantId}
                              policyTypeCode={this.props.policyTypeCode}
                              depreciationTypes={this.props.depreciationTypes}
                              showTrawickPaymentScreen={this.props.showTrawickPaymentScreen}
                              stepClaimSummaryData={this.props.stepClaimSummaryData}
                            />
                          </div>
                        </Collapsible>
                      </div>
                    );
                  })}
                </div>
                <ModalNotice isOpen={notice} onClose={this.closeModal} />
                <div className="d-none">
                  <LoginPage />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

SummaryScreen.propTypes = {
  onRequestClaimJson: PropTypes.func,
  loadClaimList: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
  claim: PropTypes.object,
  downLoadSummary: PropTypes.func,
  updateSelectedClaimNumber: PropTypes.func,
  form: PropTypes.any,
  stepTripCancellationAndTripInterruptionData: PropTypes.any,
  stepTripCancellationTugoData: PropTypes.any,
  stepTripCancellationTravellerTugoData: PropTypes.any,
  stepTripInterruptionTugoData: PropTypes.any,
  stepOptimumMedicalBenefitsTugoData: PropTypes.any,
  stepStandardVTCMedicalBenefitsTugoData: PropTypes.any,
  stepTravellerMedicalBenefitsTugoData: PropTypes.any,
  stepMedicalExpensesTugoData: PropTypes.any,
  stepOtherTugoData: PropTypes.any,
  stepBaseVictorsMedicalTugoData: PropTypes.any,
  stepStudentMedicalBenefitsTugoData: PropTypes.any,
  stepADAndDBenefitsTugoData: PropTypes.any,
  stepBaggageAndPersonalItemsTravellerTugoData: PropTypes.any,
  stepRentalCarProtectionTravellerTugoData: PropTypes.any,
  stepOtherInsuranceCoverageTugoData: PropTypes.any,
  stepOtherData: PropTypes.any,
  stepDeclarationData: PropTypes.any,
  stepSupportingDocumentsData: PropTypes.any,
  stepClaimSummaryData: PropTypes.any,
  claimTypes: PropTypes.any,
  claimPaymentVersion: PropTypes.any,
  showElectronicConsentDocument: PropTypes.bool,
  jsonVersion: PropTypes.string,
  claimTypesInit: PropTypes.array,
  showRequiredDocument: PropTypes.bool,
  showZurichUHC: PropTypes.bool,
  claimantId: PropTypes.any,
  policyTypeCode: PropTypes.string,
  policyPlanIds: PropTypes.any,
  depreciationTypes: PropTypes.array,
  showTrawickPaymentScreen: PropTypes.bool,
  onChangeLocale: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  claim: makeSelectClaimList(),
  form: makeSelectStepWhatHappened(),
  stepTripCancellationAndTripInterruptionData: makeSelectStepTripCancellationAndTripInterruption(),
  stepTripCancellationTugoData: makeSelectStepTripCancellationTugo(),
  stepTripCancellationTravellerTugoData: makeSelectStepTripCancellationTravellerTugo(),
  stepTripInterruptionTugoData: makeSelectTripInterruptionTugo(),
  stepOptimumMedicalBenefitsTugoData: makeSelectOptimumMedicalBenefitsTugo(),
  stepStandardVTCMedicalBenefitsTugoData: makeSelectStandardVTCMedicalBenefitsTugo(),
  stepTravellerMedicalBenefitsTugoData: makeSelectTravellerMedicalBenefitsTugo(),
  stepMedicalExpensesTugoData: makeSelectMedicalExpensesTugoStep(),
  stepOtherTugoData: makeSelectStepOtherTugo(),
  stepBaseVictorsMedicalTugoData: makeSelectBaseVictorsMedicalTugo(),
  stepStudentMedicalBenefitsTugoData: makeSelectStudentMedicalBenefitsTugo(),
  stepADAndDBenefitsTugoData: makeSelectADAndDBenefitsTugo(),
  stepBaggageAndPersonalItemsTravellerTugoData: makeSelectBaggageAndPersonalItemsTravellerTugo(),
  stepRentalCarProtectionTravellerTugoData: makeSelectRentalCarProtectionTravellerTugo(),
  stepOtherInsuranceCoverageTugoData: makeSelectStepOtherInsuranceCoverageTugo(),
  stepOtherData: makeSelectStepOther(),
  stepDeclarationData: makeSelectStepDeclaration(),
  stepSupportingDocumentsData: makeSelectStepSupportingDocuments(),
  stepClaimSummaryData: makeSelectStepClaimSummary(),
  claimTypes: makeSelectClaimTypes(),
  claimPaymentVersion: makeSelectClaimPaymentVersion(),
  showElectronicConsentDocument: makeSelectShowElectronicConsentDocument(),
  jsonVersion: makeSelectJSONVersion(),
  claimTypesInit: makeSelectInitClaimTypeList(),
  showRequiredDocument: makeSelectShowRequiredDocument(),
  showZurichUHC: makeSelectShowZurichUHC(),
  claimantId: makeSelectClaimantId(),
  policyTypeCode: makeSelectPolicyTypeCode(),
  policyPlanIds: makeSelectPolicyPlanIds(),
  depreciationTypes: makeSelectDepreciationTypes(),
  showTrawickPaymentScreen: makeSelectShowTrawickPaymentScreen(),
});

function mapDispatchToProps(dispatch) {
  return {
    onRequestClaimJson: (params) => {
      dispatch(setAuthenticationToken(params.token));
      dispatch(setSelectedPolicyId(params.policyNumber));
      dispatch(updateSelectedClaimId(params.claimNumber));
      dispatch(getShowElectronicConsent());
      dispatch(loadClaimList());
      dispatch(loadClaimFromSummary());
      dispatch(getClaimTypes(true));
    },
    loadClaimList: () => dispatch(loadClaimList()),
    getClaimTypes: () => dispatch(getClaimTypes()),
    getShowElectronicConsent: () => dispatch(getShowElectronicConsent()),
    downLoadSummary: (cb) => dispatch(downLoadSummary(cb)),
    updateSelectedClaimNumber: (claimNumber) =>
      dispatch(updateSelectedClaimNumber(claimNumber)),
    makeError: (s) => dispatch(makeError(s)),
    makeDirty: (s) => dispatch(makeDirty(s)),
    makeValid: (s) => dispatch(makeValid(s)),
    onChangeLocale: (locale) => dispatch(changeLocale(locale)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);

const withReducer = injectReducer({ key: 'claims', reducer });
const withStepWhatHappenedReducer = injectReducer({ key: 'stepWhatHappened', reducer: stepWhatHappenedReducer });
const withMedicalExpensesTugoStepReducer = injectReducer({ key: 'medicalExpensesTugoStep', reducer: medicalExpensesTugoStepReducer });
const withStepOtherTugoReducer = injectReducer({ key: 'stepOtherTugo', reducer: stepOtherTugoReducer });
const withBaseVictorsMedicalTugoReducer = injectReducer({ key: 'baseVictorsMedicalTugo', reducer: baseVictorsMedicalTugoReducer });
const withStudentMedicalBenefitsTugoReducer = injectReducer({ key: 'studentMedicalBenefitsTugo', reducer: studentMedicalBenefitsTugoReducer });
const withStepTripCancellationTugoReducer = injectReducer({ key: 'stepTripCancellationTugo', reducer: stepTripCancellationTugoReducer });
const withStepTripCancellationTravellerTugoReducer = injectReducer({ key: 'stepTripCancellationTravellerTugo', reducer: stepTripCancellationTravellerTugoReducer });
const withTripInterruptionTugoReducer = injectReducer({ key: 'tripInterruptionTugo', reducer: tripInterruptionTugoReducer });
const withStandardVTCMedicalBenefitsTugoReducer = injectReducer({ key: 'standardVTCMedicalBenefitsTugo', reducer: standardVTCMedicalBenefitsTugoReducer });
const withTravellerMedicalBenefitsTugoReducer = injectReducer({ key: 'travellerMedicalBenefitsTugo', reducer: travellerMedicalBenefitsTugoReducer });
const withOptimumMedicalBenefitsTugoReducer = injectReducer({ key: 'optimumMedicalBenefitsTugo', reducer: optimumMedicalBenefitsTugoReducer });
const withADAndDBenefitsTugoReducer = injectReducer({ key: 'adAndDBenefitsTugo', reducer: adAndDBenefitsTugoReducer });
const withBaggageAndPersonalItemsTravellerTugoReducer = injectReducer({ key: 'baggageAndPersonalItemsTravellerTugo', reducer: baggageAndPersonalItemsTravellerTugoReducer });
const withRentalCarProtectionTravellerTugoReducer = injectReducer({ key: 'rentalCarProtectionTravellerTugo', reducer: rentalCarProtectionTravellerTugoReducer });
const withStepOtherInsuranceCoverageTugoReducer = injectReducer({ key: 'stepOtherInsuranceCoverageTugo', reducer: stepOtherInsuranceCoverageTugoReducer });
const withSaga = injectSaga({ key: 'claims', saga });
const withStepWhatHappenedSaga = injectSaga({ key: 'stepWhatHappened', saga: stepWhatHappenedSaga });
const withLoginSaga = injectSaga({ key: 'oauth', saga: loginSaga });
const withLoginReducer = injectReducer({ key: 'oauth', reducer: loginReducer });

export default compose(
  withStepWhatHappenedReducer,
  withMedicalExpensesTugoStepReducer,
  withStepOtherTugoReducer,
  withBaseVictorsMedicalTugoReducer,
  withStudentMedicalBenefitsTugoReducer,
  withStepTripCancellationTugoReducer,
  withStepTripCancellationTravellerTugoReducer,
  withTripInterruptionTugoReducer,
  withStandardVTCMedicalBenefitsTugoReducer,
  withTravellerMedicalBenefitsTugoReducer,
  withOptimumMedicalBenefitsTugoReducer,
  withADAndDBenefitsTugoReducer,
  withBaggageAndPersonalItemsTravellerTugoReducer,
  withRentalCarProtectionTravellerTugoReducer,
  withStepOtherInsuranceCoverageTugoReducer,
  withReducer,
  withStepWhatHappenedSaga,
  withSaga,
  withLoginReducer,
  withLoginSaga,
  withConnect
)(SummaryScreen);



// WEBPACK FOOTER //
// ./app/containers/SummaryScreen/index.js